import { render } from "./CardScheduler.vue?vue&type=template&id=3a5c5714"
import script from "./CardScheduler.vue?vue&type=script&lang=js"
export * from "./CardScheduler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__